Math.easeInOutQuad = function(t, b, c, d) {
  t /= d / 2
  if (t < 1) {
    return c / 2 * t * t + b
  }
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
var requestAnimFrame = (function() {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) { window.setTimeout(callback, 1000 / 60) }
})()

/**
   * Because it's so fucking difficult to detect the scrolling element, just move them all
   * @param {number} amount
   */
function move(amount) {
  document.documentElement.scrollTop = amount
  document.body.parentNode.scrollTop = amount
  document.body.scrollTop = amount
}

function position() {
  return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop
}

/**
   * @param {number} to
   * @param {number} duration
   * @param {Function} callback
   */
export function scrollTo(to, duration, callback) {
  const start = position()
  const change = to - start
  const increment = 20
  let currentTime = 0
  duration = (typeof (duration) === 'undefined') ? 500 : duration
  var animateScroll = function() {
    // increment the time
    currentTime += increment
    // find the value with the quadratic in-out easing function
    var val = Math.easeInOutQuad(currentTime, start, change, duration)
    // move the document.body
    move(val)
    // do the animation unless its over
    if (currentTime < duration) {
      requestAnimFrame(animateScroll)
    } else {
      if (callback && typeof (callback) === 'function') {
        // the animation is done so lets callback
        callback()
      }
    }
  }
  animateScroll()
}

/**
 * 获取子节点相对于其父节点的坐标位置（即子节点左上角相对于父节点的偏移量）
 * @param {* node} child 
 * @param {* node} parent 
 * @returns 
 */
export function getChildOffsetRelativeToParent(child, parent) {
  if (!child || !parent) {
    return null; // 如果没有找到节点，则返回null
  }

  const childRect = child.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();
  console.log(childRect, parentRect)

  // 获取子节点相对于父节点的top和left偏移量
  let offsetTop = childRect.top - parentRect.top;
  let offsetLeft = childRect.left - parentRect.left;

  // 考虑到CSS变换等可能影响实际位置的情况，需要加上边框、内边距的影响
  // 这里假设父节点没有CSS变换，如果有则需进一步处理
  if (window.getComputedStyle(parent).position === 'relative') {
    offsetTop -= parseFloat(window.getComputedStyle(parent).borderTopWidth);
    offsetLeft -= parseFloat(window.getComputedStyle(parent).borderLeftWidth);
    offsetTop += parseFloat(window.getComputedStyle(parent).paddingTop);
    offsetLeft += parseFloat(window.getComputedStyle(parent).paddingLeft);
  }

  return { top: offsetTop, left: offsetLeft };
}


/**
 * 获取dom在文档中的位置坐标
 * @param {node} e 
 * @returns {object<{left: Number, top: Number}>}
 */
export function getNodeOffset(e) {
    function getTop(ev){
      let offset = ev.offsetTop;
      if(ev.offsetParent != null){
        offset += getTop(ev.offsetParent);
      }         
      return offset;
    }
  
    function getLeft(ev){
      let offset = ev.offsetLeft;
      if(ev.offsetParent != null){
        offset += getLeft(ev.offsetParent);
      }         
      return offset;
    }
    
    return {left: getLeft(e), top: getTop(e)}
  }

/**
 * 查询 plate 存在滚动条的所有父节点
 * @param {node} element (default: document.body) 默认以整个文档为范围进行查询
 */
export function findscroller(element = document.body) {
    let that = this
    element.onscroll = () => {
      // 过滤
      if(element.contains(that.plate)){
        let {top, left} = that.getNodeOffset(that.plate)
        that.plateObj.top = top - element.scrollTop
        that.plateObj.left = left - element.scrollLeft
      }
    }
    Array.from(element.children).forEach(its => that.findscroller(its))
  }